import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import App from './mainframe';
import Login from './Login/AdminLogin';
import MainPage from './MainPage';
import CreateGame from './Menu/CreateGame';
import GameRoom from './GameRoom';
import './styles/global.css';

function LocationLogger() {
  const location = useLocation();
  console.log('[LocationLogger] Current path:', location.pathname);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <LocationLogger />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<App><MainPage /></App>} />
      <Route path="/main" element={<App><MainPage /></App>} />
      <Route path="/create-game" element={<App><CreateGame /></App>} />
      <Route path="/game/:roomId" element={<App><GameRoom /></App>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);
